import { render, staticRenderFns } from "./customButton.vue?vue&type=template&id=6b079c99&scoped=true&"
import script from "./customButton.vue?vue&type=script&lang=js&"
export * from "./customButton.vue?vue&type=script&lang=js&"
import style0 from "./customButton.vue?vue&type=style&index=0&id=6b079c99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b079c99",
  null
  
)

export default component.exports